import React, { Component, PropTypes } from 'react';
import LoadingIndicator from 'components/LoadingIndicator';
import SearchPanel from 'components/SearchPanel';
import AssignedAccount from 'records/AssignedAccount';
import { List } from 'immutable';
import Account from 'components/UserSelector/Account';
import { reduxForm } from 'redux-form/immutable';

import classNames from 'classnames';
import { SEARCH_FIELD_LABEL } from 'constants/account';

@reduxForm({
    form: 'changeAccountForm',
    enableReinitialize: true,
})
export default class ExternalAccounts extends Component {
    constructor(props) {
        super(props);
        this.state = {
            searchItemsList: new List(),
            searchAccountsResult: new List(),
            searchKeywords: null,
            filteredAccounts: [],
        }
    }

    static propTypes = {
        accounts: PropTypes.object,
        dispatch: PropTypes.func,
        fetchAccounts: PropTypes.func,
        onAccountSelect: PropTypes.func,
        onSelectAccount: PropTypes.func,
        selectedAccount: PropTypes.shape({
            opcoId: PropTypes.string,
            customerId: PropTypes.string,
            accountId: PropTypes.string,
            accountType: PropTypes.string,
        }),
        meta: PropTypes.shape({
            scLoading: PropTypes.bool,
        }),
        renderAccountStatBar: PropTypes.func,
        includeInactives: PropTypes.bool,
    };

    /**
     * search account by adding a key word
     * @param {String} kn key change
     * @param {String} key keyword
     */
    onSearch = (kn, key) => {
        const { accounts } = this.props;

        if (key) {
            let searchAccounts = AssignedAccount.filterAccountsByCustomerNum(accounts, key);
            let sortedItemsList = searchAccounts.sort((itemOne, itemTwo) =>
                itemOne.get('name').localeCompare(itemTwo.get('name'))
                || itemOne.get('accountId').localeCompare(itemTwo.get('accountId')));

            if (kn === 'KeyChange') {
                this.setState({ searchItemsList: sortedItemsList });
            }

            if (kn === 'Enter' || kn === 'Search') {
                this.setState({ searchAccountsResult: sortedItemsList, searchKeywords: key });
            }
        } else {
            this.onClear();
        }
    }

    onItemClick = (customerNum, skey) => {
        const { accounts } = this.props;
        const accountSearchResult = AssignedAccount.filterAccountsByCustomerNum(accounts, customerNum);
        this.setState({
            searchAccountsResult: accountSearchResult,
            searchKeywords: skey,
        });
    }

    onClear = () => {
        this.setState({
            searchItemsList: new List(),
            searchAccountsResult: new List(),
            searchKeywords: null,
        });
    }
    renderAccountItems() {
        const { accounts, selectedAccount, onSelectAccount, meta: { accLoading } } = this.props;
        const { searchKeywords, searchAccountsResult } = this.state;

        const searchAccounts = (searchKeywords) ? searchAccountsResult : accounts;
        return (
            <LoadingIndicator loading={accLoading}>
                <div className={classNames('accounts-list list-scrolling-area')}>
                    {searchAccounts.map(item => {
                        return (
                            <Account
                                key={item.get('accountId')}
                                selectedAccountId={selectedAccount.accountId}
                                onSelect={onSelectAccount}
                                data={item}
                            />
                        );
                    })}
                </div>
            </LoadingIndicator>
        );
    }

    renderFilterComponent() {
        const { searchItemsList } = this.state;
        return (
            <div className={'filter-area'}>
                <div className={'accounts-searchbox'}>
                    <SearchPanel
                        searchItemsList={searchItemsList}
                        onSearch={this.onSearch}
                        onClear={this.onClear}
                        onItemClick={this.onItemClick}
                        itemSource='ChangeAccountItems'
                        searchPlaceholder={SEARCH_FIELD_LABEL}
                    />
                </div>
            </div>
        )
    }

    componentDidMount() {
        this.props.fetchAccounts();
    }

    componentDidUpdate(prevProps) {
        const {
            includeInactives,
            fetchAccounts,
        } = this.props;
        const { includeInactives: didIncludeInactives } = prevProps;

        if (includeInactives !== didIncludeInactives) {
            fetchAccounts(includeInactives);
        }
    }

    render() {
        const { renderAccountStatBar } = this.props;
        const { searchAccountsResult } = this.state;
        return (
            <div className={'accounts-wrapper'}>
                {this.renderFilterComponent()}
                {renderAccountStatBar(searchAccountsResult.size)}
                {this.renderAccountItems()}
            </div>
        )
    }
}